"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3016],{

/***/ 97254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ IterableBannerSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/common/IterableWrapper.tsx
var IterableWrapper = __webpack_require__(25153);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@care/iterable-display/dist/index.js + 16 modules
var dist = __webpack_require__(46207);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./src/components/hooks/useFeatureFlag.ts
var useFeatureFlag = __webpack_require__(19500);
;// CONCATENATED MODULE: ./src/components/common/IterableBanner.tsx







var ref;
var getIterableAmplitudeData = function(message) {
    var ref1, ref2;
    return {
        messageId: message.metadata.messageId,
        campaignId: message.metadata.campaignId,
        placementId: message.metadata.placementId,
        campaign: (ref1 = message.payload) === null || ref1 === void 0 ? void 0 : ref1.campaign,
        assetLocation: "VHP",
        assetText: (ref = (ref2 = message.elements) === null || ref2 === void 0 ? void 0 : ref2.body) !== null && ref !== void 0 ? ref : /* istanbul ignore next */ "",
        assetType: "banner"
    };
};
var IterableBanner = function(param) {
    var placementId = param.placementId, slotProps = param.slotProps;
    var iterableCampaignFlag = (0,useFeatureFlag/* default */.Z)("visitor-iterable-campaign-active");
    var isIterableCampaignActive = (iterableCampaignFlag === null || iterableCampaignFlag === void 0 ? void 0 : iterableCampaignFlag.value) === true;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: isIterableCampaignActive ? "active-iterable-campaign" : "",
        sx: {
            "&.active-iterable-campaign": {
                minHeight: {
                    xs: "54px",
                    sm: "32px"
                },
                bgcolor: "background.accent.accent1",
                display: "flex",
                alignItems: "center"
            }
        }
    }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.bannerContainer), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* IterableEmbeddedSlot */.bD, {
            placementId: Number(placementId),
            renderer: dist/* IterableEmbeddedRenderers.IterableSimpleBanner */.uG.o,
            onRender: function(message) {
                (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.iterableAssetViewed */.Sj.iterableAssetViewed, {
                    data: (0,_object_spread/* default */.Z)({}, getIterableAmplitudeData(message))
                });
            },
            onCTAClick: function(message) {
                (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.iterableAssetClicked */.Sj.iterableAssetClicked, {
                    data: (0,_object_spread/* default */.Z)({}, getIterableAmplitudeData(message))
                });
            }
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/common/IterableBannerSection.tsx



var IterableBannerSection = function() {
    var placementId = (0,IterableWrapper/* useIterablePlacementId */.d)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IterableBanner, {
        placementId: placementId
    });
};


/***/ }),

/***/ 22358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ SeoConversionBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69417);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54173);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20382);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49801);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(883);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19147);





var SeoConversionBox = function(param) {
    var enrollmentURL = param.enrollmentURL;
    var isSmallViewport = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_2__/* .useResponsive */ .F)().isSmallViewport;
    var ctaList = [
        {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            label: "Right Now",
            intent: "rightNow"
        },
        {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            label: "Within a month",
            intent: "withInMonth"
        },
        {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            label: "Just browsing",
            intent: "justBrowsing"
        }, 
    ];
    var handleCareButton = function(e) {
        var ref;
        var amplitudeData = {
            cta_location: "header",
            cta_text: (ref = e.target.textContent) === null || ref === void 0 ? void 0 : ref.toString(),
            cta_type: "button"
        };
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__/* .AmplitudeEvent.ctaInteracted */ .Sj.ctaInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        sx: {
            py: {
                xs: 6,
                sm: 8
            },
            px: 3,
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "background.accent.accent1"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                mb: 4,
                mt: 0,
                textAlign: "center",
                component: "h3",
                variant: isSmallViewport ? "h2" : "display3",
                children: "When do you want a job?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                display: "flex",
                justifyContent: "center",
                flexDirection: {
                    xs: "column",
                    sm: "row"
                },
                columnGap: {
                    sm: 3
                },
                children: ctaList.map(function(item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        component: "a",
                        href: "".concat(enrollmentURL, "&intent=").concat(item.intent),
                        variant: "outlined",
                        color: "secondary",
                        size: "large",
                        sx: function(theme) {
                            return {
                                minWidth: {
                                    xs: "327px",
                                    sm: "auto"
                                },
                                border: "1px solid ".concat(theme.palette.brand.main),
                                mb: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: {
                                    xs: "flex-start",
                                    sm: "center"
                                },
                                whiteSpace: "nowrap"
                            };
                        },
                        fullWidth: true,
                        onClick: handleCareButton,
                        rel: "nofollow",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                sx: {
                                    mr: {
                                        sm: 1
                                    },
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: item.icon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                variant: "inherit",
                                sx: {
                                    flex: 1,
                                    textAlign: "center"
                                },
                                children: item.label
                            })
                        ]
                    }, item.intent);
                })
            })
        ]
    });
};


/***/ }),

/***/ 87726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ItemListSchema; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ItemListSchema = function(param) {
    var searchResultType = param.searchResultType, caregiverSearchResults = param.caregiverSearchResults, jobSearchResults = param.jobSearchResults, totalNumberOfResults = param.totalNumberOfResults, startIndex = param.startIndex;
    var createListItems = function() {
        if (searchResultType === "CAREGIVER") {
            return caregiverSearchResults.map(function(result, index) {
                var ref;
                var caregiverProfile = (ref = result.caregiver.profiles) === null || ref === void 0 ? void 0 : ref.commonCaregiverProfile;
                return {
                    "@type": "WebPage",
                    name: "".concat(result.caregiver.member.displayName, " ").concat(caregiverProfile === null || caregiverProfile === void 0 ? void 0 : caregiverProfile.bio.title),
                    url: "".concat(result.profileURL),
                    position: startIndex + index + 1
                };
            });
        }
        var _jobDetailURL;
        return jobSearchResults.map(function(result, index) {
            return {
                "@type": "ListItem",
                url: (_jobDetailURL = result.jobDetailURL) !== null && _jobDetailURL !== void 0 ? _jobDetailURL : "",
                position: startIndex + index + 1
            };
        });
    };
    var itemList = {
        "@context": {
            "@vocab": "https://schema.org/"
        },
        "@type": "ItemList",
        numberOfItems: totalNumberOfResults,
        itemListElement: createListItems()
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        "data-testid": "itemListSchema",
        type: "application/ld+json",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(itemList)
        }
    });
};


/***/ }),

/***/ 33016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JobSearchDirectory": function() { return /* binding */ JobSearchDirectory; },
  "default": function() { return /* binding */ page_JobSearchDirectory; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 13 modules
var CoreGlobalFooter = __webpack_require__(79976);
// EXTERNAL MODULE: ./src/components/common/IterableBannerSection.tsx + 1 modules
var IterableBannerSection = __webpack_require__(97254);
// EXTERNAL MODULE: ./src/context/searchDirectory/SearchDirectoryDataContext.tsx
var SearchDirectoryDataContext = __webpack_require__(32826);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/FAQSection.tsx
var FAQSection = __webpack_require__(96607);
// EXTERNAL MODULE: ./src/components/common/SeoConversionBox.tsx
var SeoConversionBox = __webpack_require__(22358);
// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/InternalLinkingSection.tsx + 1 modules
var InternalLinkingSection = __webpack_require__(53166);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/BreadcrumbsSection.tsx
var BreadcrumbsSection = __webpack_require__(38071);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/getHeroImage.ts
var getHeroImage = __webpack_require__(99661);
// EXTERNAL MODULE: ./src/helpers/getDefaultHeroImageLarge.ts
var getDefaultHeroImageLarge = __webpack_require__(80427);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/ZipCodeConversion.tsx
var ZipCodeConversion = __webpack_require__(34664);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/components/HeroConversionBox.tsx








var HeroConversionBox = function() {
    var pageData = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)();
    var isLargeViewport = (0,useResponsive/* useResponsive */.F)().isLargeViewport;
    var _seoSegmentationDetails = pageData.seoSegmentationDetails, headline = _seoSegmentationDetails.headline, subHeadline = _seoSegmentationDetails.subHeadline;
    var ctaText = "Get started";
    var handleCtaBtn = function() {
        var amplitudeData = {
            cta_text: ctaText,
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)("CTA Interacted", amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mb: {
            xs: 6,
            sm: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "h1",
                variant: isLargeViewport ? "display1" : "display2",
                color: "primary",
                sx: {
                    mb: {
                        xs: 2,
                        sm: 3
                    },
                    mt: 0
                },
                dangerouslySetInnerHTML: {
                    __html: sanitize_html_default()(he_default().decode(headline))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "p",
                variant: "body2",
                mb: 4,
                dangerouslySetInnerHTML: {
                    __html: sanitize_html_default()(he_default().decode(subHeadline.replace(/<\/?p>/g, "")))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeConversion/* ZipCodeConversion */.y, {
                showZipCodeInputField: false,
                handleCtaBtn: handleCtaBtn,
                ctaText: ctaText
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/components/section/HeroSection.tsx







var HeroSection = function() {
    var pageData = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)();
    var serviceId = pageData.seoSegmentationDetails.serviceId;
    var seoSegmentId = (0,PageAttributesContext/* usePageAttributes */.l)().seoSegmentId;
    var ref;
    var heroImage = (ref = (0,getHeroImage/* getHeroImage */.w)({
        seoSegmentId: seoSegmentId,
        serviceId: serviceId
    })) !== null && ref !== void 0 ? ref : (0,getDefaultHeroImageLarge/* getDefaultHeroImageLarge */.A)(pageData.seoSegmentationHeroImage);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "lg",
        sx: {
            mt: {
                xs: 3,
                sm: 6,
                lg: 10
            },
            mb: {
                xs: 6,
                lg: 8
            },
            px: {
                xl: 0
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            sx: {
                flexDirection: {
                    xs: "column",
                    sm: "row"
                },
                alignItems: {
                    sm: "center"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroConversionBox, {})
                }),
                heroImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "img",
                        src: heroImage,
                        alt: "Hero image",
                        sx: {
                            width: "100%",
                            objectFit: "cover",
                            pl: {
                                sm: 4,
                                lg: 6
                            }
                        }
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(89609);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Container/Container.js
var Container_Container = __webpack_require__(32045);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/NoSearchResults.tsx
var NoSearchResults = __webpack_require__(91195);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/SearchResults.tsx
var SearchResults = __webpack_require__(53653);
// EXTERNAL MODULE: ./src/components/SearchResults/Pagination.tsx
var Pagination = __webpack_require__(6551);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/useSearchResults.ts + 2 modules
var useSearchResults = __webpack_require__(28748);
// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Drawer/Drawer.js
var Drawer = __webpack_require__(96040);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/utils/filtersStorage.ts
var filtersStorage = __webpack_require__(85627);
;// CONCATENATED MODULE: ./src/utils/filters.ts




var getMoreFilterValues = function(moreFilters) {
    var moreFiltersValues = {};
    moreFilters.forEach(function(element) {
        var item = constants/* MORE_FILTERS_LIST.find */.j4.find(function(x) {
            return x.value === element;
        });
        if (item && item.key) {
            var filter = {};
            filter[item.key] = true;
            moreFiltersValues = (0,_object_spread/* default */.Z)({}, moreFiltersValues, filter);
        }
    });
    return moreFiltersValues;
};
var filterMultiToggleValues = function(event, toggleValues) {
    var value = event.target.value;
    var existing = toggleValues.find(function(element) {
        return element === value;
    });
    var update = toggleValues.map(function(x) {
        return x;
    });
    if (existing === undefined) {
        update.push(value);
    } else {
        update.splice(update.findIndex(function(element) {
            return element === value;
        }), 1);
        var item = constants/* MORE_FILTERS_LIST.find */.j4.find(function(x) {
            return x.value === value;
        });
        if (item && item.key) {
            (0,filtersStorage/* removeFilter */.ku)(item.key);
        }
    }
    return update;
};
/*
 * Moving filter to top when its on bottom of screen in small screens
 */ var handleFilterAnimation = function(isMobile, ref, navID) {
    if (isMobile) {
        /**
     * Scroll filter to top of page accounting for the height of the sticky nav and some additional padding
     */ var element = ref.current;
        if (element) {
            var filteringOffSetY = (window.scrollY || window.pageYOffset) + element.getBoundingClientRect().top;
            var navMain = document.querySelector(navID);
            var navHeight = navMain ? navMain.scrollHeight : 0;
            window.scrollTo(0, filteringOffSetY - navHeight);
        }
    }
};
var getFilterData = function() {
    var data = {
        displayFilter: false,
        moreFilter: false,
        jobDetailsFilter: false
    };
    var filters = (0,filtersStorage/* loadFilters */.dm)();
    if (filters) {
        var filterKeys = Object.keys(filters).filter(function(x) {
            var returnVal = false;
            if (x !== "radius" && filters[x] !== null && !Number.isNaN(filters[x])) {
                returnVal = true;
            }
            if (typeof filters[x] === "string" && filters[x].length > 0) {
                returnVal = true;
            }
            return returnVal;
        });
        data.displayFilter = filterKeys.length > 0;
        data.moreFilter = filterKeys.includes("nonSmoker") || filterKeys.includes("hasCar");
        data.jobDetailsFilter = filterKeys.includes("newJobsOnly") || filterKeys.includes("jobStartingSoon");
    }
    return data;
};

;// CONCATENATED MODULE: ./src/utils/sortFilters.ts

/**
 * Sorts a filter Array to match the order of a "sorting" array
 * @param  {string} filtersArr filter to be sorted
 * @param  {string} argServiceIdForMember serviceIdForMember ID of current segment
 * @return {Array}  sorted array
 */ var sortFilters = function(filtersArr, argServiceIdForMember) {
    var sortArray = constants/* SEO_FILTERS_ORDER */.F0[argServiceIdForMember];
    try {
        return filtersArr.slice().sort(function(filter1, filter2) {
            return sortArray.indexOf(filter1) - sortArray.indexOf(filter2);
        });
    } catch (e) {
        return filtersArr;
    }
};
/* harmony default export */ var utils_sortFilters = (sortFilters);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormGroup/FormGroup.js + 1 modules
var FormGroup = __webpack_require__(53457);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/FilterButton/FilterButton.js
var FilterButton = __webpack_require__(18181);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Checkbox/Checkbox.js + 9 modules
var Checkbox = __webpack_require__(11725);
;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Age.tsx











var Age = function(props) {
    // Build initial schedule state based on PROVIDER_AGES
    var defaultAges = (0,react.useMemo)(function() {
        return constants/* PROVIDER_AGES.reduce */.hf.reduce(function(accum, age) {
            var ages = accum;
            // Add a new entry to the object and set its default value as false
            ages[age.value] = false;
            return ages;
        }, {});
    }, []);
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var ref = (0,react.useState)(defaultAges), state = ref[0], setState = ref[1];
    var ref1 = (0,react.useState)(false), isSelected = ref1[0], setIsSelected = ref1[1];
    var handleChange = function(event) {
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, event.target.name, event.target.checked)));
    };
    // create an array of checkbox names that are checked
    var getCheckedOptions = function(allCheckboxes) {
        return Object.entries(allCheckboxes).reduce(function(prevVal, curVal) {
            // if the item is checked, add it
            if (curVal[1]) {
                prevVal.push(curVal[0]);
            }
            return prevVal;
        }, []);
    };
    var handleApply = function() {
        var checkedOptions = getCheckedOptions(state);
        var ageData = {
            ages: checkedOptions
        };
        setIsSelected(checkedOptions.length > 0);
        (0,filtersStorage/* saveFilters */.HJ)(ageData, onChange);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, ageData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setState(defaultAges);
            setIsSelected(false);
        }
    }, [
        isClear,
        defaultAges
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        label: "Age",
        field: "interactive-component",
        selected: isSelected,
        onApply: handleApply,
        onClick: handleClick,
        sx: {
            color: "text.primary"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
            children: constants/* PROVIDER_AGES.map */.hf.map(function(age) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        name: age.value,
                        onChange: handleChange,
                        checked: state[age.value]
                    }),
                    label: (0,he.decode)(age.label)
                }, age.value);
            })
        })
    });
};
/* harmony default export */ var LegacyFilters_Age = (Age);

// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/NativeSelect/NativeSelect.js
var NativeSelect = __webpack_require__(88566);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevron.js
var Icon24UtilityChevron = __webpack_require__(68720);
;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Availability.tsx










var Availability = function(props) {
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var ref = (0,react.useState)({
        availability: ""
    }), available = ref[0], setAvailable = ref[1];
    var iconComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
            component: "select",
            height: "20px",
            width: "20px"
        });
    };
    var options = constants/* AVAILABILITIES.map */.km.map(function(availability) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
            value: availability.value,
            children: availability.label
        }, availability.label);
    });
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)({
            availability: available.availability === "" ? null : available.availability
        }, onChange);
        var amplitudeData = {
            availability: available.availability
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, amplitudeData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setAvailable({
                availability: ""
            });
        }
    }, [
        isClear
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        field: "Availability",
        label: "Availability",
        selected: available.availability !== "",
        onApply: handleApply,
        onClick: handleClick,
        sx: {
            color: "text.primary"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
            variant: "standard",
            sx: {
                width: "325px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                fullWidth: true,
                onChange: function(e) {
                    return setAvailable((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, available), {
                        availability: e.target.value
                    }));
                },
                inputProps: {
                    name: "option",
                    id: "field-native-select"
                },
                value: available.availability,
                IconComponent: iconComponent,
                children: options
            })
        })
    });
};
/* harmony default export */ var LegacyFilters_Availability = (Availability);

// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(33841);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/TextField/TextField.js
var TextField = __webpack_require__(53340);
;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Distance.tsx











var Distance = function(props) {
    var ref = (0,react.useState)({
        zipCode: "",
        milesFromZipCode: 5
    }), distance = ref[0], setDistance = ref[1];
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var iconComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
            component: "select",
            height: "20px",
            width: "20px"
        });
    };
    var options = constants/* MILES */.YK && constants/* MILES.map */.YK.map(function(mile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
            value: mile.value,
            children: mile.label
        }, mile.value);
    });
    /*
   * handle apply
   */ var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)({
            radius: {
                unit: globalTypes/* DistanceUnit.MILES */.Rb.MILES,
                value: distance.milesFromZipCode
            },
            zipcode: distance.zipCode
        }, onChange);
        var amplitudeData = {
            zipCode: distance.zipCode,
            milesFromZipCode: distance.milesFromZipCode
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, amplitudeData);
    };
    var handleMilesChange = function(e) {
        setDistance((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, distance), {
            milesFromZipCode: parseInt(e.target.value, 10)
        }));
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setDistance({
                zipCode: "",
                milesFromZipCode: 5
            });
        }
    }, [
        isClear
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        field: "Distance",
        label: "Distance",
        selected: Boolean(distance.zipCode && distance.milesFromZipCode),
        onApply: handleApply,
        onClick: handleClick,
        sx: {
            color: "text.primary"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            spacing: 4,
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                        variant: "standard",
                        component: "fieldset",
                        fullWidth: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            id: "zip",
                            required: true,
                            InputLabelProps: {
                                shrink: false
                            },
                            name: "zip",
                            label: "Zip Code",
                            error: distance.zipCode.length < 5,
                            value: distance.zipCode,
                            onChange: function(e) {
                                var value = e.target.value;
                                if (/^\d{0,5}$/.test(value)) {
                                    setDistance((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, distance), {
                                        zipCode: value
                                    }));
                                }
                            },
                            sx: {
                                minWidth: 0
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                        variant: "standard",
                        component: "fieldset",
                        fullWidth: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                htmlFor: "field-native-select",
                                children: "Within"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                                onChange: handleMilesChange,
                                inputProps: {
                                    name: "option",
                                    id: "field-native-select"
                                },
                                value: distance.milesFromZipCode,
                                IconComponent: iconComponent,
                                children: options
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var LegacyFilters_Distance = (Distance);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/PayRate.tsx










var PayRate = function(props) {
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange, isJobSearch = props.isJobSearch;
    var ref = (0,react.useState)({
        hourlyRate: ""
    }), payRate = ref[0], setPayRate = ref[1];
    var iconComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
            component: "select",
            height: "20px",
            width: "20px"
        });
    };
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)({
            hourlyRate: payRate.hourlyRate
        }, onChange);
        var amplitudeData = {
            hourlyRate: payRate.hourlyRate
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, amplitudeData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setPayRate({
                hourlyRate: ""
            });
        }
    }, [
        isClear
    ]);
    var renderPayRate = function() {
        if (isJobSearch) {
            return constants/* PAY_RATES_JOB */.$c;
        }
        return constants/* PAY_RATES */.N3;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        field: "Pay Rate",
        label: "Pay Rate",
        selected: Boolean(payRate.hourlyRate),
        onApply: handleApply,
        onClick: handleClick,
        sx: {
            color: "text.primary"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
            variant: "standard",
            sx: {
                width: "325px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                    htmlFor: "demo-native-select",
                    children: isJobSearch ? "RATE PER HOUR" : "COST PER HOUR"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                    fullWidth: true,
                    onChange: function(e) {
                        return setPayRate((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payRate), {
                            hourlyRate: e.target.value
                        }));
                    },
                    inputProps: {
                        name: "option",
                        id: "field-native-select"
                    },
                    value: payRate.hourlyRate,
                    IconComponent: iconComponent,
                    children: renderPayRate().map(function(rate) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: rate.value,
                            children: rate.label
                        }, rate.label);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var LegacyFilters_PayRate = (PayRate);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Services.tsx








var Services = function(props) {
    var ref = (0,react.useState)([]), filterState = ref[0], setFilterState = ref[1];
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange, serviceId = props.serviceId;
    var isSelected = function(value) {
        var existing = filterState.find(function(element) {
            return element === value;
        });
        return existing !== undefined;
    };
    var servicesList;
    var filterLabel = "Services";
    switch(serviceId){
        case constants/* ServiceId.SENIRCARE */.Xs.SENIRCARE:
            servicesList = constants/* SERVICES_LIST_SENIOR_CARE */.wv;
            break;
        case constants/* ServiceId.HOUSEKEEP */.Xs.HOUSEKEEP:
            servicesList = constants/* SERVICES_LIST_HOUSEKEEPING */.qk;
            break;
        case constants/* ServiceId.TUTORINGX */.Xs.TUTORINGX:
            servicesList = constants/* SERVICES_LIST_TUTORING */.Uw;
            filterLabel = "Subject Area";
            break;
        case constants/* ServiceId.PETCAREXX */.Xs.PETCAREXX:
            servicesList = constants/* SERVICES_LIST_PET_CARE */.$f;
            break;
        case constants/* ServiceId.CAREGIGSX */.Xs.CAREGIGSX:
            servicesList = constants/* SERVICES_LIST_CARE_GIGS */.rR;
            break;
        case constants/* ServiceId.SPCLNEEDS */.Xs.SPCLNEEDS:
            servicesList = constants/* SERVICES_LIST_SPECIAL_NEEDS */.de;
            break;
        default:
            break;
    }
    var handleFilterMultiToggle = function(event) {
        setFilterState(filterMultiToggleValues(event, filterState));
    };
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)({
            services: filterState
        }, onChange);
        var amplitudeData = {
            services: filterState
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, amplitudeData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setFilterState([]);
        }
    }, [
        isClear
    ]);
    var renderCheckbox = function(value, label) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                name: "options",
                checked: isSelected(value)
            }),
            label: label,
            onChange: handleFilterMultiToggle,
            value: value,
            sx: function(theme) {
                return {
                    padding: theme.spacing(0, 2.25)
                };
            }
        }, value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        field: "Services",
        label: filterLabel,
        selected: filterState.length > 0,
        onApply: handleApply,
        onClick: handleClick,
        sx: {
            color: "text.primary"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
            variant: "standard",
            component: "fieldset",
            sx: {
                width: "325px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                children: servicesList && servicesList.map(function(service) {
                    return renderCheckbox(service.value, service.label);
                })
            })
        })
    });
};
/* harmony default export */ var LegacyFilters_Services = (Services);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Schedule.tsx










var Schedule = function(props) {
    // Build initial schedule state based on PROVIDER_SCHEDULES
    var defaultSchedule = (0,react.useMemo)(function() {
        return constants/* PROVIDER_SCHEDULES.reduce */.Jd.reduce(function(accum, schedule) {
            var schedules = accum;
            // Add a new entry to the object and set its default value as false
            schedules[schedule.value] = false;
            return schedules;
        }, {});
    }, []);
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var ref = (0,react.useState)(defaultSchedule), state = ref[0], setState = ref[1];
    var ref1 = (0,react.useState)(false), isSelected = ref1[0], setIsSelected = ref1[1];
    var handleChange = function(event) {
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, event.target.name, event.target.checked)));
    };
    // create an array of checkbox names that are checked
    var getCheckedOptions = function(allCheckboxes) {
        return Object.entries(allCheckboxes).reduce(function(prevVal, curVal) {
            // if the item is checked, add it
            if (curVal[1]) {
                prevVal.push(curVal[0]);
            }
            return prevVal;
        }, []);
    };
    var handleApply = function() {
        var checkedOptions = getCheckedOptions(state);
        var ScheduleData = {
            schedule: checkedOptions
        };
        setIsSelected(checkedOptions.length > 0);
        (0,filtersStorage/* saveFilters */.HJ)(ScheduleData, onChange);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, ScheduleData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setState(defaultSchedule);
            setIsSelected(false);
        }
    }, [
        isClear,
        defaultSchedule
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        label: "Schedule",
        field: "interactive-component",
        selected: isSelected,
        onApply: handleApply,
        onClick: handleClick,
        sx: {
            color: "text.primary"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
            children: constants/* PROVIDER_SCHEDULES.map */.Jd.map(function(schedule) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        name: schedule.value,
                        onChange: handleChange,
                        checked: state[schedule.value]
                    }),
                    label: schedule.label
                }, schedule.value);
            })
        })
    });
};
/* harmony default export */ var LegacyFilters_Schedule = (Schedule);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Slider/Slider.js + 6 modules
var Slider = __webpack_require__(50734);
;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Hours.tsx






var Hours = function(props) {
    var defaultHours = (0,react.useMemo)(function() {
        return [
            5,
            21
        ];
    }, []);
    var defaultIsOvernight = false;
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var ref = (0,react.useState)(defaultHours), hours = ref[0], setHours = ref[1];
    var ref1 = (0,react.useState)(defaultIsOvernight), isOvernight = ref1[0], setIsOvernight = ref1[1];
    var ref2 = (0,react.useState)(false), isSelected = ref2[0], setIsSelected = ref2[1];
    var onChangeTr = function(val) {
        /* istanbul ignore else (unreachable) */ if (Array.isArray(val)) {
            setHours(val);
        } else {
            setHours([
                val,
                val
            ]);
        }
    };
    var onChangeOvernight = function(e) {
        setIsOvernight(e.target.checked);
    };
    var formatTime = function(time) {
        return time < 10 ? "0".concat(time, ":00") : "".concat(time, ":00");
    };
    var handleApply = function() {
        var hoursData = {
            hours: {
                startTime: formatTime(hours[0]),
                endTime: formatTime(hours[1]),
                isOvernight: isOvernight
            }
        };
        setIsSelected(hours[0] !== defaultHours[0] || hours[1] !== defaultHours[1] || isOvernight !== defaultIsOvernight);
        (0,filtersStorage/* saveFilters */.HJ)(hoursData, onChange);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, hoursData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setHours(defaultHours);
            setIsOvernight(defaultIsOvernight);
            setIsSelected(false);
        }
    }, [
        isClear,
        defaultHours,
        defaultIsOvernight
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterButton/* default */.Z, {
        label: "Hours",
        field: "field",
        selected: isSelected,
        onApply: handleApply,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                component: "p",
                gutterBottom: true,
                children: "Daytime Hours:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                timeIncrements: 60,
                min: 5,
                max: 21,
                value: [
                    hours[0],
                    hours[1]
                ],
                marks: true,
                timeMode: true,
                unit: "",
                onChange: onChangeTr,
                sx: {
                    "& .MuiSlider-root": {
                        padding: "13px 0"
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 0.5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        name: "isOvernight",
                        onChange: onChangeOvernight,
                        checked: isOvernight
                    }),
                    label: "Overnight hours"
                })
            })
        ]
    });
};
/* harmony default export */ var LegacyFilters_Hours = (Hours);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/YearsOfExp.tsx










var YearsOfExp = function(props) {
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var initialData = (0,react.useMemo)(function() {
        return {
            yearsOfExperience: ""
        };
    }, []);
    var ref = (0,react.useState)(initialData), experience = ref[0], setExperience = ref[1];
    var iconComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
            component: "select",
            height: "20px",
            width: "20px"
        });
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setExperience(initialData);
        }
    }, [
        isClear,
        initialData
    ]);
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)({
            yearsOfExperience: experience.yearsOfExperience === "" ? null : Number(experience.yearsOfExperience)
        }, onChange);
        var amplitudeData = {
            yearsOfExperience: experience.yearsOfExperience
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        field: "YearsOfExp",
        label: "Years Of Exp",
        selected: Boolean(experience.yearsOfExperience),
        onApply: handleApply,
        onClick: handleClick,
        sx: {
            color: "text.primary"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
            variant: "standard",
            sx: {
                width: "325px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                fullWidth: true,
                onChange: function(e) {
                    return setExperience((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, experience), {
                        yearsOfExperience: e.target.value
                    }));
                },
                inputProps: {
                    name: "option",
                    id: "field-native-select"
                },
                value: experience.yearsOfExperience,
                IconComponent: iconComponent,
                children: constants/* EXPERIENCES.map */.UO.map(function(exp) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: exp.value,
                        children: exp.label
                    }, exp.label);
                })
            })
        })
    });
};
/* harmony default export */ var LegacyFilters_YearsOfExp = (YearsOfExp);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Divider/Divider.js
var Divider = __webpack_require__(81956);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Card/Card.js
var Card = __webpack_require__(37088);
// EXTERNAL MODULE: ./node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/MoreFilters.tsx










var ref = config_default()(), NEXT_ASSET_URL = ref.publicRuntimeConfig.NEXT_ASSET_URL;
var MoreFilters = function(props) {
    var ref = (0,react.useState)([]), moreFilters = ref[0], setMoreFilters = ref[1];
    var isClear = props.isClear, onChange = props.onChange, enrollmentURL = props.enrollmentURL, onClose = props.onClose;
    var isSelected = function(value, key) {
        var filters = (0,filtersStorage/* loadFilters */.dm)();
        var existing;
        existing = moreFilters.find(function(element) {
            return element === value;
        });
        if (existing === undefined && filters !== null) {
            existing = Object.keys(filters).find(function(element) {
                return element === key;
            });
        }
        return existing !== undefined;
    };
    var ref1 = (0,react.useState)(false), isUpdated = ref1[0], setIsUpdated = ref1[1];
    var handleFilterMultiToggle = function(event) {
        setMoreFilters(filterMultiToggleValues(event, moreFilters));
        setIsUpdated(true);
    };
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)(getMoreFilterValues(moreFilters), onChange);
        onClose();
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setMoreFilters([]);
        }
    }, [
        isClear
    ]);
    var renderCheckbox = function(value, label, disabled, key) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                disabled: disabled,
                name: "options",
                checked: isSelected(value, key)
            }),
            label: label,
            value: value,
            sx: function(theme) {
                return (0,_define_property/* default */.Z)({
                    display: "flex",
                    flexDirection: "row-reverse",
                    justifyContent: "space-between"
                }, theme.breakpoints.up("md"), {
                    display: "inline-flex",
                    flexDirection: "row"
                });
            },
            labelPlacement: "end",
            onChange: handleFilterMultiToggle
        }, value);
    };
    var handleJoinNowButton = function() {
        var amplitudeData = {
            cta_text: 'Join now (CTA within "more filters")'
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        p: 4,
        width: {
            md: "767px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                color: "primary",
                py: 1.25,
                px: 0.5,
                children: "More Filters"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                children: [
                    constants/* MORE_FILTERS_LIST.map */.j4.map(function(moreFilter) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 6,
                            py: 0.5,
                            px: {
                                xs: 0.5,
                                md: 2
                            },
                            children: renderCheckbox(moreFilter.value, moreFilter.label, moreFilter.disabled, moreFilter.key)
                        }, moreFilter.label);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden/* default */.Z, {
                        implementation: "css",
                        mdDown: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sx: {
                                    "& > img": {
                                        opacity: 0.2
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(NEXT_ASSET_URL, "/images/disabled-filters.png"),
                                    alt: "Caregiver Details",
                                    width: "100%",
                                    height: "90%"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                careVariant: "subtle",
                sx: function(theme) {
                    return (0,_define_property/* default */.Z)({
                        width: "300px",
                        top: "258px",
                        position: "fixed",
                        left: "37px",
                        zIndex: 1
                    }, theme.breakpoints.up("sm"), {
                        left: "230px"
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                    sx: function(theme) {
                        return {
                            padding: theme.spacing(4),
                            textAlign: "center"
                        };
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            children: "Create a free account to access all filters!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            href: enrollmentURL,
                            color: "primary",
                            variant: "contained",
                            sx: function(theme) {
                                return {
                                    marginTop: theme.spacing(4)
                                };
                            },
                            onClick: handleJoinNowButton,
                            children: "Join now"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mt: 2,
                textAlign: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "secondary",
                        variant: "outlined",
                        size: "small",
                        onClick: function() {
                            return onClose();
                        },
                        sx: function(theme) {
                            return {
                                marginRight: theme.spacing(2)
                            };
                        },
                        children: "Close"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "secondary",
                        variant: "contained",
                        disabled: !isUpdated,
                        onClick: handleApply,
                        size: "small",
                        children: "Apply"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LegacyFilters_MoreFilters = (MoreFilters);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/ExperienceWithAges.tsx








var ExperienceWithAges = function(props) {
    var ref = (0,react.useState)([]), filterState = ref[0], setFilterState = ref[1];
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var isSelected = function(value) {
        var existing = filterState.find(function(element) {
            return element === value;
        });
        return existing !== undefined;
    };
    var handleFilterMultiToggle = function(event) {
        setFilterState(filterMultiToggleValues(event, filterState));
    };
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)({
            experienceWithAges: filterState
        }, onChange);
        var amplitudeData = {
            services: filterState
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, amplitudeData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setFilterState([]);
        }
    }, [
        isClear
    ]);
    var renderCheckbox = function(value, label) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                name: "options",
                checked: isSelected(value)
            }),
            label: label,
            onChange: handleFilterMultiToggle,
            value: value,
            sx: function(theme) {
                return {
                    padding: theme.spacing(0, 2.25)
                };
            }
        }, value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        field: "Experience with Ages",
        label: "Experience with Ages",
        selected: filterState.length > 0,
        onApply: handleApply,
        onClick: handleClick,
        sx: {
            color: "text.primary"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
            variant: "standard",
            component: "fieldset",
            sx: {
                width: "325px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                children: constants/* EXPERIENCE_WITH_AGES_LIST */.js && constants/* EXPERIENCE_WITH_AGES_LIST.map */.js.map(function(service) {
                    return renderCheckbox(service.value, service.label);
                })
            })
        })
    });
};
/* harmony default export */ var LegacyFilters_ExperienceWithAges = (ExperienceWithAges);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/JobDetails.tsx










var JobDetails_ref = config_default()(), JobDetails_NEXT_ASSET_URL = JobDetails_ref.publicRuntimeConfig.NEXT_ASSET_URL;
var JobDetails = function(props) {
    // Build initial schedule filterState
    var defaultFilterState = function() {
        var filters = (0,filtersStorage/* loadFilters */.dm)();
        return (0,_object_spread/* default */.Z)({
            jobsStartingSoon: false,
            newJobsOnly: false
        }, filters);
    };
    var ref = (0,react.useState)(defaultFilterState()), filterState = ref[0], setFilterState = ref[1];
    var isClear = props.isClear, onChange = props.onChange, enrollmentURL = props.enrollmentURL, onClose = props.onClose;
    var handleChange = function(event) {
        setFilterState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterState), (0,_define_property/* default */.Z)({}, event.target.name, event.target.checked)));
    };
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)(filterState, onChange);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, filterState);
        onClose();
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setFilterState({
                jobsStartingSoon: false,
                newJobsOnly: false
            });
        }
    }, [
        isClear
    ]);
    var handleJoinNowButton = function() {
        var amplitudeData = {
            cta_text: 'Join now (CTA within "job details")'
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        p: 4,
        width: {
            md: "767px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                color: "primary",
                py: 1.25,
                px: 0.5,
                children: "Job Details"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 6,
                        py: 1.25,
                        px: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        name: "jobsStartingSoon",
                                        onChange: handleChange,
                                        checked: filterState.jobsStartingSoon
                                    }),
                                    label: "Jobs starting soon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        name: "newJobsOnly",
                                        onChange: handleChange,
                                        checked: filterState.newJobsOnly
                                    }),
                                    label: "New jobs only"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden/* default */.Z, {
                        implementation: "css",
                        mdDown: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sx: {
                                    "& > img": {
                                        opacity: 0.2
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(JobDetails_NEXT_ASSET_URL, "/images/disabled-filters.png"),
                                    alt: "Job Details",
                                    width: "100%",
                                    height: "90%"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                careVariant: "subtle",
                sx: function(theme) {
                    return (0,_define_property/* default */.Z)({
                        width: "300px",
                        top: "258px",
                        position: "fixed",
                        left: "37px",
                        zIndex: 1
                    }, theme.breakpoints.up("sm"), {
                        left: "230px"
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                    sx: function(theme) {
                        return {
                            padding: theme.spacing(4),
                            textAlign: "center"
                        };
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            children: "Create a free account to access all filters!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            href: enrollmentURL,
                            rel: "nofollow",
                            color: "primary",
                            variant: "contained",
                            sx: function(theme) {
                                return {
                                    marginTop: theme.spacing(4)
                                };
                            },
                            onClick: handleJoinNowButton,
                            children: "Join now"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mt: 2,
                textAlign: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "secondary",
                        variant: "outlined",
                        size: "small",
                        onClick: function() {
                            return onClose();
                        },
                        sx: function(theme) {
                            return {
                                marginRight: theme.spacing(2)
                            };
                        },
                        children: "Close"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "secondary",
                        variant: "contained",
                        // disabled={!isUpdated}
                        onClick: handleApply,
                        size: "small",
                        children: "Apply"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LegacyFilters_JobDetails = (JobDetails);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/JobType.tsx










var JobTypeFilter = function(props) {
    var defaultState = (0,react.useMemo)(function() {
        return {
            jobType: constants/* JOB_TYPE_FILTER_OPTIONS.ANY */.G5.ANY
        };
    }, []);
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var ref = (0,react.useState)(defaultState), state = ref[0], setState = ref[1];
    var ref1 = (0,react.useState)(false), isSelected = ref1[0], setIsSelected = ref1[1];
    var handleChange = function(event) {
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            jobType: event.target.value
        }));
    };
    var iconUtilityChevron = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
            component: "select",
            height: "20px",
            width: "20px"
        });
    };
    var handleApply = function() {
        var jobTypeData = {
            jobType: state.jobType
        };
        setIsSelected(true);
        (0,filtersStorage/* saveFilters */.HJ)(jobTypeData, onChange);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, jobTypeData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setState(defaultState);
            setIsSelected(false);
        }
    }, [
        isClear,
        defaultState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        label: "Job Type",
        field: "Job Type",
        selected: isSelected,
        onApply: handleApply,
        onClick: handleClick,
        sx: {
            color: "text.primary"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
            variant: "standard",
            sx: {
                width: "325px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                fullWidth: true,
                IconComponent: iconUtilityChevron,
                onChange: handleChange,
                value: state.jobType,
                inputProps: {
                    name: "jobType"
                },
                children: Object.entries(constants/* JOB_TYPE_FILTER_OPTIONS */.G5).map(function(jobType) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: jobType[0],
                        children: jobType[1]
                    }, jobType[0]);
                })
            })
        })
    });
};
/* harmony default export */ var JobType = (JobTypeFilter);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Filters.tsx
























var classes = {
    btnFilter: function(theme) {
        return {
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1.5),
            width: "auto",
            height: theme.spacing(4),
            minWidth: theme.spacing(10),
            borderRadius: theme.spacing(1),
            borderColor: theme.palette.care.grey[300]
        };
    },
    clearAll: function(theme) {
        return (0,_define_property/* default */.Z)({
            marginLeft: theme.spacing(2.5),
            display: "inline",
            cursor: "pointer",
            color: "#015AC8"
        }, theme.breakpoints.down("md"), {
            marginLeft: theme.spacing(-1.5)
        });
    }
};
var Filters = function(param) {
    var searchFilters = param.searchFilters, searchResultsHeader = param.searchResultsHeader, onChange = param.onChange, searchFiltersRef = param.searchFiltersRef, enrollmentURL = param.enrollmentURL, serviceIdForMember = param.serviceIdForMember, serviceId = param.serviceId, showMoreFilters = param.showMoreFilters, showJobDetails = param.showJobDetails, searchingFor = param.searchingFor;
    var ref = (0,react.useState)(false), isSideDrawerOpen = ref[0], setIsSideDrawerOpen = ref[1];
    var ref1 = (0,react.useState)(false), isClear = ref1[0], setIsClear = ref1[1];
    var ref2 = (0,react.useState)(false), displayFilter = ref2[0], setDisplayFilter = ref2[1];
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var ref3 = (0,react.useState)(false), hasMoreFilters = ref3[0], setHasMoreFilters = ref3[1];
    var ref4 = (0,react.useState)(false), hasJobDetails = ref4[0], setHasJobDetails = ref4[1];
    // All job segmentation pages have the same filters
    var allJobFilters = [
        globalTypes/* SEOSegmentationSearchFilters.DISTANCE */.Iy.DISTANCE,
        globalTypes/* SEOSegmentationSearchFilters.JOB_TYPE */.Iy.JOB_TYPE,
        globalTypes/* SEOSegmentationSearchFilters.PAY_RATE */.Iy.PAY_RATE
    ];
    var handleApplyChanges = function() {
        var filterData = getFilterData();
        setDisplayFilter(filterData.displayFilter);
        setHasMoreFilters(filterData.moreFilter);
        setHasJobDetails(filterData.jobDetailsFilter);
        if (filterData.displayFilter && !isClear) {
            onChange();
        }
    };
    var trackEvent = function(filter) {
        return function() {
            var amplitudeData = {
                filter: filter
            };
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.clickOnSegmentationFilter */.Sj.clickOnSegmentationFilter, amplitudeData);
        };
    };
    var clearFiltersData = function() {
        (0,filtersStorage/* clearFilters */.K5)();
        setIsClear(true);
        handleApplyChanges();
    };
    // Call clearFilters function on page load to remove localStorage data from filters
    (0,react.useEffect)(function() {
        (0,filtersStorage/* clearFilters */.K5)();
    }, []);
    (0,react.useEffect)(function() {
        if (isClear) {
            setIsClear(false);
            onChange();
        }
    }, [
        isClear,
        onChange
    ]);
    var sideDrawerClose = function() {
        return setIsSideDrawerOpen(false);
    };
    var handleMobileAnimation = function() {
        return handleFilterAnimation(isMobile, searchFiltersRef, "#navMain");
    };
    var flipSideDrawer = function() {
        trackEvent("More Filters")();
        setIsSideDrawerOpen(!isSideDrawerOpen);
    };
    var renderFilterOptions = function(name) {
        switch(name){
            case globalTypes/* SEOSegmentationSearchFilters.AGE */.Iy.AGE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Age, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.AVAILABILITY */.Iy.AVAILABILITY:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Availability, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.DISTANCE */.Iy.DISTANCE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Distance, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.EXPERIENCE_WITH_AGES */.Iy.EXPERIENCE_WITH_AGES:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_ExperienceWithAges, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.HOURS */.Iy.HOURS:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Hours, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.JOB_TYPE */.Iy.JOB_TYPE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobType, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.PAY_RATE */.Iy.PAY_RATE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_PayRate, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges,
                    isJobSearch: showJobDetails
                });
            case globalTypes/* SEOSegmentationSearchFilters.SCHEDULE */.Iy.SCHEDULE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Schedule, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.SERVICES */.Iy.SERVICES:
            case globalTypes/* SEOSegmentationSearchFilters.SUBJECT_AREA */.Iy.SUBJECT_AREA:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Services, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges,
                    serviceId: serviceId
                });
            case globalTypes/* SEOSegmentationSearchFilters.YEARS_OF_EXPERIENCE */.Iy.YEARS_OF_EXPERIENCE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_YearsOfExp, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            default:
                return null;
        }
    };
    var getFilters = function() {
        if (searchingFor === globalTypes/* SEOSegmentationSearchingFor.ALL_JOB */.yh.ALL_JOB || searchingFor === globalTypes/* SEOSegmentationSearchingFor.SEEKER_JOB */.yh.SEEKER_JOB) {
            return allJobFilters;
        }
        if (!searchFilters) return [];
        return utils_sortFilters(searchFilters, serviceIdForMember);
    };
    var filtersList = getFilters();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        pt: 3,
        ref: searchFiltersRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h2",
                fontWeight: "400",
                lineHeight: "24px",
                mb: 3,
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: sanitize_html_default()(he_default().decode(searchResultsHeader))
                },
                sx: function(theme) {
                    return {
                        color: theme.palette.care.grey[900]
                    };
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                children: [
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 2,
                        children: displayFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            onClick: clearFiltersData,
                            sx: classes.clearAll,
                            children: "Clear All"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            overflowX: "scroll",
                            overflowY: "hidden",
                            whiteSpace: "nowrap",
                            "&::-ms-overflow-style": "none",
                            "&::-webkit-scrollbar": {
                                display: "none"
                            }
                        },
                        children: [
                            filtersList.map(function(filterOption) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 11,
                                    display: "inline-block",
                                    mr: 2,
                                    onClick: handleMobileAnimation,
                                    children: renderFilterOptions(filterOption)
                                }, filterOption);
                            }),
                            showMoreFilters && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: hasMoreFilters ? "contained" : "outlined",
                                        sx: function(theme) {
                                            var ref;
                                            return {
                                                paddingLeft: theme.spacing(1.5),
                                                paddingRight: theme.spacing(1.5),
                                                backgroundColor: theme.palette.background.primary,
                                                width: "auto",
                                                height: theme.spacing(4),
                                                minWidth: theme.spacing(10),
                                                borderRadius: theme.spacing(1),
                                                borderColor: (ref = theme.palette.border) === null || ref === void 0 ? void 0 : ref.interactive.disabled
                                            };
                                        },
                                        color: hasMoreFilters ? "secondary" : "inherit",
                                        onClick: flipSideDrawer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body3",
                                            children: "More Filters"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* SideDrawer */.jC, {
                                        open: isSideDrawerOpen,
                                        onClose: sideDrawerClose,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_MoreFilters, {
                                            onClose: sideDrawerClose,
                                            isClear: isClear,
                                            onChange: handleApplyChanges,
                                            enrollmentURL: enrollmentURL
                                        })
                                    })
                                ]
                            }),
                            showJobDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: hasJobDetails ? "contained" : "outlined",
                                        sx: function(theme) {
                                            var ref;
                                            return {
                                                paddingLeft: theme.spacing(1.5),
                                                paddingRight: theme.spacing(1.5),
                                                backgroundColor: theme.palette.background.primary,
                                                width: "auto",
                                                height: theme.spacing(4),
                                                minWidth: theme.spacing(10),
                                                borderRadius: theme.spacing(1),
                                                borderColor: (ref = theme.palette.border) === null || ref === void 0 ? void 0 : ref.interactive.disabled
                                            };
                                        },
                                        color: hasJobDetails ? "secondary" : "inherit",
                                        onClick: flipSideDrawer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body3",
                                            children: "Job Details"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* SideDrawer */.jC, {
                                        open: isSideDrawerOpen,
                                        onClose: sideDrawerClose,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_JobDetails, {
                                            onClose: sideDrawerClose,
                                            isClear: isClear,
                                            onChange: handleApplyChanges,
                                            enrollmentURL: enrollmentURL
                                        })
                                    })
                                ]
                            }),
                            displayFilter && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                onClick: clearFiltersData,
                                sx: classes.clearAll,
                                children: "Clear All"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LegacyFilters_Filters = (Filters);

// EXTERNAL MODULE: ./src/components/feature/searchDirectory/ItemListSchema.tsx
var ItemListSchema = __webpack_require__(87726);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/ProfileAvatar/ProfileAvatar.js
var ProfileAvatar = __webpack_require__(49975);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./src/utils/formatStartDate.ts
var formatStartDate = __webpack_require__(26008);
;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/components/JobCard/JobSeekerAvatar.tsx






var JobSeekerAvatar = function(param) {
    var job = param.job, isClientSearchResultsQuery = param.isClientSearchResultsQuery;
    var startDate = job.job.startDate;
    var _seekerAvatar;
    var profileAvatarProps = {
        alt: "Seeker profile avatar for ".concat(job.job.title),
        size: "squareSmall",
        src: (_seekerAvatar = job.seekerAvatar) !== null && _seekerAvatar !== void 0 ? _seekerAvatar : undefined,
        slotProps: {
            avatar: {
                imgProps: isClientSearchResultsQuery ? {
                    loading: "eager"
                } : {
                    loading: "lazy"
                }
            }
        }
    };
    var formattedStartDate = (0,formatStartDate/* formatStartDate */.O)(startDate);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, profileAvatarProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            spacing: 0.5,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    component: "div",
                    textAlign: "center",
                    children: formattedStartDate.month.toLocaleUpperCase()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h1",
                    component: "div",
                    textAlign: "center",
                    children: formattedStartDate.day.toUpperCase()
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Tag/Tag.js
var Tag = __webpack_require__(96670);
;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/components/JobCard/helpers/createJobTagList.ts


/**
 * Creates an array of job tags from job information.
 *
 * @param {object} params - The job information parameters
 * @param {string} [params.type] - The job type identifier that will be mapped to a display name via JOB_TYPES
 * @param {object} [params.hourlyRateRange] - The hourly rate range information
 * @param {string|Date} [params.startDate] - The job start date
 * @param {string} [params.city] - The city where the job is located
 * @param {string} [params.state] - The state where the job is located
 * @returns {string[]} An array of non-null job tag strings
 */ var createJobTagList = function(param) {
    var type = param.type, hourlyRateRange = param.hourlyRateRange, startDate = param.startDate, city = param.city, state = param.state;
    var ref, ref1, ref2, ref3;
    var hourlyRateRangeText = "$".concat(hourlyRateRange === null || hourlyRateRange === void 0 ? void 0 : (ref = hourlyRateRange.hourlyRateFrom) === null || ref === void 0 ? void 0 : ref.amount, " - $").concat(hourlyRateRange === null || hourlyRateRange === void 0 ? void 0 : (ref1 = hourlyRateRange.hourlyRateTo) === null || ref1 === void 0 ? void 0 : ref1.amount, "/hr");
    var startDateFormatted = (0,formatStartDate/* formatStartDate */.O)(startDate);
    return [
        type ? "".concat(constants/* JOB_TYPES */.d9[type]) : null,
        (hourlyRateRange === null || hourlyRateRange === void 0 ? void 0 : (ref2 = hourlyRateRange.hourlyRateFrom) === null || ref2 === void 0 ? void 0 : ref2.amount) && (hourlyRateRange === null || hourlyRateRange === void 0 ? void 0 : (ref3 = hourlyRateRange.hourlyRateTo) === null || ref3 === void 0 ? void 0 : ref3.amount) ? hourlyRateRangeText : null,
        startDate ? "starts ".concat(startDateFormatted.month, " ").concat(startDateFormatted.day) : null,
        city && state ? "".concat(city, ", ").concat(state) : null, 
    ].filter(function(item) {
        return item !== null;
    });
};

;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/components/JobCard/JobTagList.tsx





var JobTagList = function(param) {
    var job = param.job, sx = param.sx;
    var city = job.city, state = job.state, type = job.type, _job = job.job, startDate = _job.startDate, hourlyRateRange = _job.hourlyRateRange;
    var tagList = createJobTagList({
        type: type,
        hourlyRateRange: hourlyRateRange,
        startDate: startDate,
        city: city,
        state: state
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: (0,_to_consumable_array/* default */.Z)(Array.isArray(sx) ? sx : [
            sx
        ]),
        children: tagList.map(function(tag) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.ZP, {
                type: "grey",
                sx: {
                    mr: 1
                },
                children: tag
            }, tag);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/components/JobCard/JobOverview.tsx





var JobOverview = function(param) {
    var searchResult = param.searchResult;
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    var targetValue = isSmallViewport ? undefined : "_blank";
    var _seoSegmentationJob = searchResult.seoSegmentationJob, title = _seoSegmentationJob.job.title, jobDetailURL = searchResult.jobDetailURL;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        xs: 12,
        container: true,
        columnSpacing: isSmallViewport ? 2 : 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    variant: "h3",
                    underline: "none",
                    href: jobDetailURL,
                    target: targetValue,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobSeekerAvatar, {
                        job: searchResult.seoSegmentationJob,
                        isClientSearchResultsQuery: false
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: true,
                alignContent: "flex-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: isSmallViewport ? "h3" : "h2",
                        children: title
                    }),
                    !isSmallViewport && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobTagList, {
                        sx: {
                            mt: 1
                        },
                        job: searchResult.seoSegmentationJob
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/common/ReadMore.tsx
var ReadMore = __webpack_require__(33424);
;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/components/JobCard/JobDescription.tsx






var JobDescription = function(param) {
    var sx = param.sx, jobDescription = param.jobDescription;
    var ref = (0,useResponsive/* useResponsive */.F)(), isSmallViewport = ref.isSmallViewport, isMediumViewport = ref.isMediumViewport;
    var ref1 = (0,react.useState)(false), isExpanded = ref1[0], setIsExpanded = ref1[1];
    var getCharLimit = function() {
        if (isSmallViewport) {
            return 200;
        }
        if (isMediumViewport) {
            return 120;
        }
        return 140;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: (0,_to_consumable_array/* default */.Z)(Array.isArray(sx) ? sx : [
            sx
        ]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* ReadMore */.y, {
            color: "textPrimary",
            component: "div",
            variant: "body2",
            charLimit: getCharLimit(),
            value: jobDescription,
            showMoreLabel: isExpanded ? "less" : "read more",
            onClick: function() {
                return setIsExpanded(!isExpanded);
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/components/JobCard/JobCard.tsx








var JobCard = function(param) {
    var searchResult = param.searchResult;
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    // Skip profiles without a URL
    if (searchResult.jobDetailURL === null) return null;
    var validSearchResult = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchResult), {
        jobDetailURL: searchResult.jobDetailURL
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        width: "100%",
        px: 3,
        py: 4,
        borderRadius: isSmallViewport ? 0 : 6,
        sx: {
            mt: {
                xs: 0.5,
                sm: 4
            },
            "&:first-of-type": {
                mt: 4
            }
        },
        bgcolor: "background.primary",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobOverview, {
                searchResult: validSearchResult
            }),
            isSmallViewport && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobTagList, {
                sx: {
                    mt: 2
                },
                job: validSearchResult.seoSegmentationJob
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mt: {
                    xs: 2,
                    sm: 3
                },
                display: "flex",
                flexWrap: isSmallViewport ? "wrap" : "nowrap",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobDescription, {
                        jobDescription: validSearchResult.seoSegmentationJob.description,
                        sx: {
                            width: {
                                xs: "100%",
                                md: "auto"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        href: validSearchResult.jobDetailURL,
                        target: isSmallViewport ? undefined : "_blank",
                        rel: "noopener",
                        size: "medium",
                        fullWidth: isSmallViewport,
                        sx: {
                            minWidth: "160px",
                            ml: {
                                xs: 0,
                                md: 4
                            },
                            mt: {
                                xs: 4,
                                md: 0
                            },
                            alignSelf: "flex-end"
                        },
                        color: "primary",
                        variant: "contained",
                        children: "See\xa0details"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/components/SearchResultsContainer.tsx














var SearchResultsContainer = function(param) {
    var Aside = param.Aside;
    var ref;
    var ref1 = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)(), seoSegmentationSearchResults = ref1.seoSegmentationSearchResults, seoSegmentationDetails = ref1.seoSegmentationDetails;
    var ref2 = (0,PageAttributesContext/* usePageAttributes */.l)(), enrollmentURL = ref2.enrollmentURL, seoSegmentId = ref2.seoSegmentId;
    var initialJobSearchResults = seoSegmentationSearchResults.jobSearchResults, initialFilters = seoSegmentationSearchResults.filters, initialPagination = seoSegmentationSearchResults.pagination;
    var isNationalPage = seoSegmentationDetails.pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL;
    var searchFiltersRef = (0,react.useRef)(null);
    var searchResultRef = (0,react.useRef)(null);
    var ref3;
    var validFilters = (ref3 = (ref = seoSegmentationDetails.searchFilters) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return item !== null;
    })) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4 = (0,useSearchResults/* useSearchResults */.s)({
        initialFilters: initialFilters,
        initialPagination: initialPagination,
        seoSegmentId: seoSegmentId,
        isNationalPage: isNationalPage,
        showUserFilters: false,
        initialSearchResults: {
            jobSearchResults: initialJobSearchResults
        }
    }), pagination = ref4.pagination, jobSearchResults = ref4.jobSearchResults, pageNumber = ref4.pageNumber, baseHandlePageClick = ref4.handlePageClick;
    var handlePageClick = function(newPage) {
        baseHandlePageClick(newPage, searchResultRef);
    };
    var handleFiltersApply = function() {
        handlePageClick(1); // pull Apply changes from localStorage but set page as 1
        router_default().push(seoSegmentId, undefined, {
            shallow: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Filters, {
                    searchFilters: validFilters,
                    searchResultsHeader: "",
                    onChange: handleFiltersApply,
                    searchFiltersRef: searchFiltersRef,
                    enrollmentURL: enrollmentURL !== null && enrollmentURL !== void 0 ? enrollmentURL : "",
                    serviceId: seoSegmentationDetails.serviceId,
                    serviceIdForMember: seoSegmentationDetails.serviceIdForMember,
                    showMoreFilters: false,
                    showJobDetails: jobSearchResults.length > 0,
                    searchingFor: seoSegmentationDetails.searchingFor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 8,
                        children: jobSearchResults.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mt: 4,
                            mb: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSearchResults/* NoSearchResults */.q, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            ref: searchResultRef,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults/* SearchResults */.s, {
                                    items: jobSearchResults,
                                    renderItem: function(item, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobCard, {
                                            searchResult: item
                                        }, "product-".concat(i));
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemListSchema/* ItemListSchema */.Q, {
                                    searchResultType: "JOB",
                                    jobSearchResults: jobSearchResults,
                                    totalNumberOfResults: pagination.totalNumberOfResults,
                                    startIndex: pagination.startIndex
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                    onPageClick: handlePageClick,
                                    pagination: pagination,
                                    segmentId: seoSegmentId,
                                    pageSelected: pageNumber
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: false,
                        md: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        bgcolor: {
                            xs: "background.default",
                            sm: "transparent"
                        },
                        item: true,
                        xs: 12,
                        md: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside, {})
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 4 modules
var ListItem = __webpack_require__(70891);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemAvatar/ListItemAvatar.js + 1 modules
var ListItemAvatar = __webpack_require__(18987);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/Icon24Edit.js
var Icon24Edit = __webpack_require__(15222);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/Icon48Jobs.js
var Icon48Jobs = __webpack_require__(30564);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/Icon24Celebrate.js
var Icon24Celebrate = __webpack_require__(54358);
;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/components/JobHowItWorks.tsx



var JobHowItWorks = function() {
    var stats = [
        {
            Icon: Icon24Edit/* default */.Z,
            primaryText: "Sign up",
            secondaryText: "Create a profile to find jobs that fit your schedule"
        },
        {
            Icon: Icon48Jobs/* default */.Z,
            primaryText: "Search for jobs",
            secondaryText: "Apply to jobs posted by local families hiring in your area"
        },
        {
            Icon: Icon24Celebrate/* default */.Z,
            primaryText: "Get hired",
            secondaryText: "Match with families, take jobs as you need them, and start earning!"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        py: {
            xs: 6,
            sm: 0
        },
        mt: {
            xs: 0,
            md: 3
        },
        ml: {
            xs: 3,
            sm: 0,
            md: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h2",
                children: "How it works"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                sx: {
                    display: {
                        xs: "block",
                        sm: "flex",
                        md: "block"
                    },
                    mt: 3,
                    maxWidth: {
                        xs: "327px",
                        sm: "100%"
                    }
                },
                children: stats.map(function(param) {
                    var Icon = param.Icon, primaryText = param.primaryText, secondaryText = param.secondaryText;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                        disableGutters: true,
                        sx: {
                            py: 0,
                            mx: 0,
                            mt: {
                                xs: 2,
                                sm: 0,
                                md: 2
                            },
                            mr: {
                                xs: undefined,
                                sm: 4,
                                md: undefined
                            },
                            "&:first-of-type": {
                                mt: 0
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar/* default */.Z, {
                                sx: {
                                    mr: {
                                        xs: 3,
                                        sm: 2,
                                        md: 3
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    sx: {
                                        bgcolor: "background.accent.accent3",
                                        height: "64px",
                                        width: "64px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        size: "40px",
                                        color: "text.primary"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                sx: {
                                    flexWrap: "wrap"
                                },
                                primaryTypographyProps: {
                                    color: "text.primary",
                                    variant: "h4"
                                },
                                primary: primaryText,
                                secondaryTypographyProps: {
                                    color: "text.secondary",
                                    variant: "body3"
                                },
                                secondary: secondaryText
                            })
                        ]
                    }, primaryText);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/components/section/SearchResultsWithAsideSection.tsx







var SearchResultsWithAsideSection = function() {
    var seoSegmentationDetails = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)().seoSegmentationDetails;
    var ref = (0,useResponsive/* useResponsive */.F)(), isSmallViewport = ref.isSmallViewport, isLargeViewport = ref.isLargeViewport;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        bgcolor: "background.secondary",
        pt: 8,
        pb: 10,
        px: {
            lg: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_Container/* default */.Z, {
            maxWidth: "lg",
            disableGutters: isSmallViewport || isLargeViewport,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: isSmallViewport ? "h1" : "display3",
                            component: "h2",
                            mb: 0,
                            mt: 0,
                            mx: isSmallViewport ? 3 : 0,
                            dangerouslySetInnerHTML: {
                                __html: seoSegmentationDetails.searchResultsHeader
                            },
                            sx: {
                                "& p:first-of-type": {
                                    margin: 0
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsContainer, {
                        Aside: JobHowItWorks
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/PictogramJobPost.js
var PictogramJobPost = __webpack_require__(91509);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/PictogramEarningMoney.js
var PictogramEarningMoney = __webpack_require__(35206);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/PictogramSuccessfulCareer.js
var PictogramSuccessfulCareer = __webpack_require__(39258);
;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/components/section/ValuePropSection.tsx






var ValuePropSection = function() {
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), segmentNameSingularLowerCase = ref.segmentNameSingularLowerCase, pageType = ref.pageType, city = ref.city, state = ref.state;
    var isLocalPage = pageType === "LOCAL";
    var valueProps = [
        {
            Icon: PictogramJobPost/* default */.Z,
            title: "Job that fits you",
            description: "Find local ".concat(segmentNameSingularLowerCase, " opportunities to fit you and your schedule")
        },
        {
            Icon: PictogramEarningMoney/* default */.Z,
            title: "Take control of your earnings",
            description: "Set your own rate and get your profile in front of families actively looking for ".concat(segmentNameSingularLowerCase, " ").concat(isLocalPage ? " in ".concat(city, ", ").concat(state) : "")
        },
        {
            Icon: PictogramSuccessfulCareer/* default */.Z,
            title: "A trusted community",
            description: "We have spent more than 15 years connecting millions of caregivers to their next opportunity"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        bgcolor: "background.primary",
        py: {
            xs: 6,
            md: 8
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_Container/* default */.Z, {
            maxWidth: "lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                columnSpacing: 8,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: isSmallViewport ? "h1" : "display3",
                            component: "h2",
                            textAlign: "center",
                            mb: 0,
                            mt: 0,
                            mx: isSmallViewport ? 3 : 0,
                            children: [
                                "Discover your next ",
                                segmentNameSingularLowerCase,
                                isLocalPage ? " in ".concat(city, ", ").concat(state) : ""
                            ]
                        })
                    }),
                    valueProps.map(function(param) {
                        var Icon = param.Icon, title = param.title, description = param.description;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 4,
                            mt: {
                                xs: 4,
                                md: 6
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                alignItems: "center",
                                justifySelf: "center",
                                display: "flex",
                                flexDirection: "column",
                                maxWidth: "500px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        size: 128
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        textAlign: "center",
                                        variant: "h3",
                                        mt: 2,
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        textAlign: "center",
                                        variant: "body2",
                                        color: "text.secondary",
                                        mt: 0.5,
                                        children: description
                                    })
                                ]
                            })
                        }, title);
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/page/JobSearchDirectory/index.tsx












var JobSearchDirectory = function(param) {
    var pageData = param.pageData;
    var enrollmentURL = (0,PageAttributesContext/* usePageAttributes */.l)().enrollmentURL;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchDirectoryDataContext/* SearchDirectoryDataProvider */.z, {
        pageData: pageData,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IterableBannerSection/* IterableBannerSection */.d, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuePropSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsWithAsideSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoConversionBox/* SeoConversionBox */.P, {
                enrollmentURL: enrollmentURL !== null && enrollmentURL !== void 0 ? enrollmentURL : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* FAQSection */.v, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLinkingSection/* InternalLinkingSection */.x, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbsSection/* BreadcrumbsSection */.L, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {
                variant: "inverse"
            })
        ]
    });
};
/* harmony default export */ var page_JobSearchDirectory = (JobSearchDirectory);


/***/ }),

/***/ 26008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ formatStartDate; }
/* harmony export */ });
/**
 * Formats a date string into an object with separate month and day properties.
 * The function converts any date format with hyphens to use forward slashes
 * before parsing and formatting.
 *
 * @param dateInput - A date string in a format that can be parsed by the Date constructor
 * @param useLongMonth - Optional boolean flag to determine if the month should be displayed
 *                      in its full form (e.g., "January" instead of "Jan"). Default is false.
 * @returns An object containing formatted month and day parts
 * @property {string} month - The formatted month (e.g., "Jan" or "January")
 * @property {string} day - The formatted day (e.g., "1")
 *
 * @example
 * // Returns { month: "Jan", day: "1" }
 * formatStartDate("2023-01-01")
 *
 * @example
 * // Returns { month: "January", day: "1" }
 * formatStartDate("2023-01-01", true)
 */ var formatStartDate = function(dateInput) {
    var useLongMonth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    // Ensure the date is consistently formatted in a format like "YYYY-MM-DD" to "YYYY/MM/DD"
    var formattedDate = new Date(dateInput.replace(/-/g, "/")).toLocaleString("en-us", {
        month: useLongMonth ? "long" : "short",
        day: "numeric"
    }).split(" ");
    return {
        month: formattedDate[0],
        day: formattedDate[1]
    };
};


/***/ })

}]);